import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList } from "@fortawesome/free-solid-svg-icons";

class SessionsSubmenu extends Component {
  render() {
    // const connectedSensors = this.props.latestData.filter(
    //   (sensorData) => sensorData?.latest_data?.length
    // );
    return (
      <div className="row">
        <div className="col pl-4">
          <h1 className="page-title-bold">Sessions</h1>
          <div>
            <Link
              to="/sessions/list-view/1"
              className={` ${
                this.props.location.pathname.includes("list-view")
                  ? "bacelink-active"
                  : "bacelink"
              }`}
            >
              <FontAwesomeIcon
                style={{ marginRight: "8px" }}
                icon={faList}
                size="sm"
              />
              List
            </Link>
            <div className="align-right">
              <span className="text-alert submenu-text-bold">
                {this.props.nrResults}
              </span>
              <span className="text-alert submenu-text">
                result{this.props.nrResults === 1 ? "" : "s"}
              </span>
            </div>
            <div className="switch-btn-line"></div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    //latestData: state.groupReducer?.latestData,
  };
}

export default withRouter(connect(mapStateToProps)(SessionsSubmenu));
